/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Dialog, DialogContent, Button, Link } from '@material-ui/core';
import { createStyles, withStyles, withTheme } from '@material-ui/core/styles';

const MicBlockedDarkEn = '/microphone/mic_block_dark_en.png';
const MicBlockedDarkFr = '/microphone/mic_block_dark_fr.png';
const MicBlockedLightEn = '/microphone/mic_block_light_en.png';
const MicBlockedLightFr = '/microphone/mic_block_light_fr.png';

const styles = createStyles(theme => ({
  title: {
    margin: 0,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  subTitle: {
    margin: 0,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 18,
    marginTop: 30,
    color: theme.palette.ava.blue,
  },
  learnMore: {
    color: theme.palette.ava.blue,
    textAlign: 'center',
    textDecoration: 'underline',
    fontSize: 16,
  },
  ok: {
    width: '60%',
    fontSize: 24,
    marginTop: 30,
    marginBottom: 15,
    borderRadius: 8,
  },
  dialog: {
    borderRadius: 18,
  },
  img: {
    width: '90%',
    boxShadow: theme.shadows[3],
    marginTop: 30,
  },
}));

// eslint-disable-next-line react/prop-types
function MicrophoneDenied({ classes, i18n, open, t, theme }) {
  const [dismissed, setDismissed] = useState(false);
  return (
    <Dialog
      onClose={() => setDismissed(true)}
      open={open && !dismissed}
      maxWidth="xs"
      fullWidth
      className={classes.dialog}
    >
      <DialogContent>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            padding: 15,
          }}
        >
          <h3 className={classes.title}>{t('modal.request.microphoneAccessDenied')}</h3>

          <h4 className={classes.subTitle}>{t('modal.request.changeMicrophoneSettings')}</h4>

          {theme.palette.type === 'dark' ? (
            <img
              className={classes.img}
              src={i18n.language === 'fr' ? MicBlockedDarkFr : MicBlockedDarkEn}
              alt={t('modal.request.microphoneAccessDenied')}
            />
          ) : (
            <img
              className={classes.img}
              src={i18n.language === 'fr' ? MicBlockedLightFr : MicBlockedLightEn}
              alt={t('modal.request.microphoneAccessDenied')}
            />
          )}

          <Button
            onClick={() => setDismissed(true)}
            disableElevation
            color="primary"
            variant="contained"
            className={classes.ok}
          >
            {t('modal.request.ok')}
          </Button>
          <Link
            className={classes.learnMore}
            target="_blank"
            href={
              i18n.language === 'fr'
                ? 'https://support.google.com/chrome/answer/2693767?hl=fr'
                : 'https://support.google.com/chrome/answer/2693767?hl=en'
            }
          >
            {t('accuracy.learnMore')}
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default withStyles(styles)(withTranslation()(withTheme(MicrophoneDenied)));
